/** Dot-path helpers ("content.items.0.title") for plain JSON data. Pure; used inside immer drafts too. */

export type Path = string;

export function splitPath(path: Path): Array<string | number> {
  return path
    .split(".")
    .filter(Boolean)
    .map((seg) => (/^\d+$/.test(seg) ? Number(seg) : seg));
}

export function getPath(obj: unknown, path: Path): unknown {
  let cur: unknown = obj;
  for (const seg of splitPath(path)) {
    if (cur === null || cur === undefined) return undefined;
    cur = (cur as Record<string | number, unknown>)[seg];
  }
  return cur;
}

/**
 * Mutating set (call on an immer draft). `undefined` deletes the key (optional fields stay absent,
 * which keeps definitions valid under strict schemas). Missing intermediate objects/arrays are created.
 */
export function setPathMut(obj: Record<string, unknown>, path: Path, value: unknown): void {
  const segs = splitPath(path);
  let cur: Record<string | number, unknown> = obj;
  for (let i = 0; i < segs.length - 1; i++) {
    const seg = segs[i]!;
    let next = cur[seg];
    if (next === null || typeof next !== "object") {
      next = typeof segs[i + 1] === "number" ? [] : {};
      cur[seg] = next;
    }
    cur = next as Record<string | number, unknown>;
  }
  const last = segs[segs.length - 1]!;
  if (value === undefined) {
    if (Array.isArray(cur) && typeof last === "number") cur.splice(last, 1);
    else delete cur[last];
  } else {
    cur[last] = value;
  }
}
